import MainLayout from "../layout";
import Page from "../page/Page";
import { useTranslation } from "react-i18next";

function CareerAdviceTeam() {
  const { t } = useTranslation();
  let title = {
    caption: t("pages.career_advice.title"),
  };

  return (
    <MainLayout title={title}>
      <Page title={t("pages.career_advice.title")} titleKey="pages.career_advice.title" isWidthSmall={true}>
        <div data-key="pages.career_advice.text" dangerouslySetInnerHTML={{ __html: t("pages.career_advice.text") }}></div>
      </Page>
    </MainLayout>
  );
}

export default CareerAdviceTeam;
